import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        buscador: {
            buscadorAvanzado: false,
            texto: '',
            organo: [],
            localizacion: [],
            fase: [],
            jurisdiccion: [],
            fuente: null,
            etiquetas: [],
            buscadorData: [],
            criterios: {}
        },
        id: 0,
        mostrarAvisoLegal: true
    },
    mutations: {},
    actions: {}
})
